import { BottleIcon, CanIcon } from './icons';

const CHECK_ICON = (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" width="14" height="14">
        <polyline points="20 6 9 17 4 12" />
    </svg>
);

const FORMAT_GROUPS = [
    {
        id: 'rtd',
        label: 'Ready to Drink',
        description: 'Cans and RTD kegs',
        Icon: CanIcon,
    },
    {
        id: 'concentrate',
        label: 'Concentrate',
        description: 'Bottles and bulk concentrate',
        Icon: BottleIcon,
    },
];

const WizardStep1Family = ({ selectedFamily, onSelectFamily }) => {
    return (
        <div className="gsp-wizard-step gsp-step1">
            <div className="gsp-step-section-header">
                <span className="gsp-step-num-badge">1</span>
                <div>
                    <h2 className="gsp-step-title">Choose an output family</h2>
                    <p className="gsp-step-subtitle">
                        Pick a family first. That hides the noise and makes the next decision obvious.
                    </p>
                </div>
            </div>

            <div className="gsp-family-grid">
                {FORMAT_GROUPS.map(({ id, label, description, Icon }) => {
                    const isSelected = selectedFamily === id;
                    return (
                        <button
                            key={id}
                            className={`gsp-family-card ${isSelected ? 'selected' : ''}`}
                            onClick={() => onSelectFamily(id)}
                            aria-pressed={isSelected}
                        >
                            {isSelected && (
                                <span className="gsp-card-checkmark">{CHECK_ICON}</span>
                            )}
                            <div className="gsp-family-icon">
                                <Icon />
                            </div>
                            <div className="gsp-family-text">
                                <strong>{label}</strong>
                                <span>{description}</span>
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default WizardStep1Family;
